import React from 'react';
import PaginatedPlainCRUD from 'components/PaginatedPlainCRUD';
import PlainCRUD, { defaultFields } from 'components/PlainCRUD';
import {
  getMarcasDeVehiculos,
  postMarcasDeVehiculos,
  patchMarcaDeVehiculo,
  deleteMarcaDeVehiculo,
} from 'api/recaudacion/marcasVehiculares';
import {
  deleteMarcaDeMotocicleta,
  getMarcasDeMotocicletas,
  patchMarcaDeMotocicleta,
  postMarcasDeMotocicletas,
} from 'api/catalogos/marcasDeMotocicletas';
import {
  deleteMarcaDeRemolque,
  getMarcasDeRemolques,
  patchMarcaDeRemolque,
  postMarcasDeRemolques,
} from 'api/catalogos/marcasDeRemolques';

const cruds = {
  vehiculos: {
    get: getMarcasDeVehiculos,
    post: postMarcasDeVehiculos,
    patch: patchMarcaDeVehiculo,
    delete: deleteMarcaDeVehiculo,
    paginated: true,
    fields: [
      defaultFields.clave,
      defaultFields.nombre,
    ],
  },
  motocicletas: {
    get: getMarcasDeMotocicletas,
    post: postMarcasDeMotocicletas,
    patch: patchMarcaDeMotocicleta,
    delete: deleteMarcaDeMotocicleta,
    paginated: false,
    fields: [
      defaultFields.clave,
      defaultFields.descripcion,
    ],
  },
  remolques: {
    get: getMarcasDeRemolques,
    post: postMarcasDeRemolques,
    patch: patchMarcaDeRemolque,
    delete: deleteMarcaDeRemolque,
    paginated: false,
    fields: [
      defaultFields.clave,
      defaultFields.descripcion,
    ],
  },
};

// eslint-disable-next-line react/prop-types
const Marcas = ({ permission }) => {
  const currentURI = window.location.href.split('-').pop();
  const {
    get,
    post,
    patch,
    delete: _delete,
    paginated,
    fields,
  } = cruds[currentURI];
  const Component = paginated ? PaginatedPlainCRUD : PlainCRUD;
  const title = `marca de ${currentURI.replace(/s$/, '')}`;
  return (
    <Component
      title={title}
      get={get}
      post={post}
      patch={patch}
      delete={_delete}
      permission={permission}
      fields={fields}
    />
  );
};

export default Marcas;
